import React, { useState, useEffect, useRef, useContext } from "react";
import { useNavigate } from "react-router-dom";
import classes from "./SilverChitPage.module.css";
import Cookies from "js-cookie";
import { spinWheelRewardApi } from "../http/http";
import video from "../assets/v.mp4";
import { LanguageContext } from "./LanguageContext";
import { SILVER, pageT } from "../utils/i18n";


const prizes = [
  "0 pts",
  "10 pts",
  "2GB data",
  "10 cash",
  "3 pts",
  "100 MB",
  "4 pts",
  "12 pts",
  "2x Pts",
];

const SilverChitPage = () => {
  const navigate = useNavigate();
  const { lang } = useContext(LanguageContext);
  const t = pageT(lang, SILVER);
  const [chitOpened, setChitOpened] = useState(false);
  const [wheelVisible, setWheelVisible] = useState(false);
  const [reward, setReward] = useState(null);
  const wheelRef = useRef(null);
  const [spinning, setSpinning] = useState(false);

  const handleChitClick = () => {
    setChitOpened(true);
    setTimeout(() => setWheelVisible(true), 1000); 
  };

 useEffect(() => {
        const token = Cookies.get("token");
        if (!token)  navigate("/");
    
      }, []);

const handleSpin = () => {
  if (spinning) return;
  setSpinning(true);
  setReward(null);

  const totalSegments = prizes.length;
  const segmentAngle = 360 / totalSegments;

  const winningIndex = Math.floor(Math.random() * totalSegments);

  const fullSpins = 5;
  const baseRotation = fullSpins * 360;

  const rotateDeg =
    baseRotation -
    winningIndex * segmentAngle -
    segmentAngle / 2 -
    90;

  if (wheelRef.current) {
    wheelRef.current.style.transition =
      "transform 4s cubic-bezier(0.1, 1, 0.3, 1)";
    wheelRef.current.style.transform = `rotate(${rotateDeg}deg)`;
  }

  setTimeout(async () => {
    const winningPrize = prizes[winningIndex];
    setReward(winningPrize);
    setSpinning(false);

    const rewardPoints = parseInt(winningPrize);
    const token = Cookies.get("token");

    try {
      await spinWheelRewardApi({
        token,
        reward_points: rewardPoints,
      });
    } catch (err) {
      console.log("Spin reward error", err);
    }
  }, 4000);
};




  const handleNextLevel = () => {
    navigate("/levelpage/11");
  };

  return (
    <div className={classes.page}>
    <video
    autoPlay
    loop
    muted
    playsInline
    className={classes.bgVideo}
  >
    <source src={video} type="video/mp4" />
  </video>
      <h1 className={classes.title}>{t.wonPrize}</h1>

      {!chitOpened && (
        <div className={classes.silverChit} onClick={handleChitClick}>
          <span className={classes.chitText}>{t.clickOpen}</span>
        </div>
      )}

      {chitOpened && !wheelVisible && (
        <div className={`${classes.silverChit} ${classes.opening}`}>
          <span className={classes.chitText}>{t.opening}</span>
        </div>
      )}

      {wheelVisible && (
        <div className={classes.wheelContainer}>
          <div className={classes.wheelWrapper}>
            <div ref={wheelRef} className={classes.wheel}>
              {prizes.map((p, idx) => (
                <div
                  key={idx}
                  className={classes.segment}
                  style={{ transform: `rotate(${(360 / prizes.length) * idx}deg)` }}
                >
                  <span>{p}</span>
                </div>
              ))}
            </div>
            <div className={classes.pointer}>▼</div>
          </div>

          {!reward ? (
            <button className={classes.spinBtn} onClick={handleSpin} disabled={spinning}>
              {spinning ? t.spinning : t.spinWheel}
            </button>
          ) : (
            <>
              <p className={classes.rewardText}>✨ {t.youWon} {reward}!</p>
              <button className={classes.nextBtn} onClick={handleNextLevel}>
                {t.nextLevel}
              </button>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default SilverChitPage;
